import { render, staticRenderFns } from "./DocumentationTab.vue?vue&type=template&id=515c2dee&scoped=true&"
var script = {}
import style0 from "./DocumentationTab.vue?vue&type=style&index=0&id=515c2dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c2dee",
  null
  
)

export default component.exports